import React from 'react';

const Logo = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: { container: 'w-8 h-8', dim: 32 },
    md: { container: 'w-12 h-12', dim: 48 },
    lg: { container: 'w-16 h-16', dim: 64 },
    xl: { container: 'w-20 h-20', dim: 80 }
  };

  const currentSize = sizes[size] || sizes.md;

  return (
    <div className={`relative flex-shrink-0 ${currentSize.container} ${className}`}>
      <picture>
        <source srcSet="/logo.webp" type="image/webp" />
        <img 
          src="/logo.png" 
          alt="Unya Mee Sustainable Fashion Logo Warsaw" 
          width={currentSize.dim}
          height={currentSize.dim}
          className="w-full h-full object-contain"
          loading="eager"
          decoding="async"
        />
      </picture>
    </div>
  );
};

export default Logo;